module.exports = __webpack_public_path__ + "assets/img/江永智-code.0c4e55df.jpg";